import StarRating from "../pages/Avaliacao/StarRating";

export default function PaginatedQuestions({
  perguntas,
  sendDataStar,
  paginaAtual,
  perguntasPorPagina = 4,
  notas,
}) {
  const inicio = paginaAtual * perguntasPorPagina;
  const fim = inicio + perguntasPorPagina;
  const perguntasPagina = perguntas.slice(inicio, fim);

  return (
    <div className="mt-6 p-6 w-full flex justify-center">
      <div className="grid grid-cols-2 gap-x-28 gap-y-12 w-full max-w-[1500px]">
        {perguntasPagina.map((pergunta) => {
          const notaAtual =
            notas.find((n) => n.pergunta_id === pergunta.id)?.nota || 0;

          return (
            <div
              key={pergunta.id}
              className="flex flex-col items-start text-left gap-4"
            >
              <h2 className="text-[2rem] leading-tight text-deepBlue font-tommy font-semibold">
                {pergunta.texto}
              </h2>

              <StarRating
                sendDataStar={sendDataStar}
                pergunta_id={pergunta.id}
                notaAtual={notaAtual}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
